'use strict';

import Data from './data/data.module.js';
import Utils from './utils.service.js';
import Config from './config.provider.js';
import VirtualPaginator from './virtual-paginator.factory.js';
import Webcore from './webcore.provider.js';
import Idle from './idle.service.js';
import Offline from './offline.service.js';
import I18n from './i18n.service.js';
import Cache from './cache.service.js';
import Permissions from './permissions.service.js';
import Clipboard from './clipboard.service.js';
import Resource from './resource.factory.js';
import Brands from './brands.service.js';
import GoogleMaps from './google-maps.service.js';
import IconService from './icon.service.js';

export default angular
  .module('maestro.services', [
    Data,
    Brands,
    Utils,
    Config,
    VirtualPaginator,
    Webcore,
    Idle,
    Offline,
    I18n,
    Cache,
    Permissions,
    Clipboard,
    Resource,
    GoogleMaps,
    IconService,
  ])
  .name;
